// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"3d533a77","402":"011300ef","430":"1371c795","624":"a8595c99","678":"ccc0472d","888":"a241d9bc","945":"9e586ec2"}[chunkId] + ".chunk.js";
};